export default __webpack_public_path__ + "media/1.3b547.png";